/*
 * @Author: xiaomin xm@pzds.com
 * @Date: 2025-03-18 10:36:52
 * @LastEditors: xiaomin xm@pzds.com
 * @LastEditTime: 2025-03-18 15:36:24
 * @FilePath: \mobile-v3\src\plugins\analytics.client.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

export default ({store}) => {
    const script1 = document.createElement('script')
	script1.innerHTML = `
          (function(win, export_obj) {
            win['LogAnalyticsObject'] = export_obj;
            if (!win[export_obj]) {
              function _collect() {
                _collect.q.push(arguments);
              }
              _collect.q = _collect.q || [];
              win[export_obj] = _collect;
            }
            win[export_obj].l = +new Date();
          })(window, 'collectEvent');
        `

	// const script2 = document.createElement('script')
	// script2.src = 'https://lf3-data.volccdn.com/obj/data-static/log-sdk/collect/5.0/collect-rangers-v5.1.12.js'
	// script2.async = true
	// script2.onload = () => {
	// 	// 初始化SDK
	// 	window.collectEvent('init', {
	// 		app_id: 20007223,
	// 		channel_domain: 'https://gator.volces.com', // 设置数据上送地址
	// 		ab_channel_domain: 'https://tab.volces.com', // 分流请求域名
	// 		// enable_debug: true,
	// 		log: true, // true:开启日志，false:关闭日志
	// 		autotrack: false, // 全埋点开关，true开启，false关闭
	// 		enable_ab_test: true, // boolean类型，是否开启A/B实验功能
	// 		enable_ab_visual: false, // boolean类型，按需开启，默认关闭，是否开启A/B实验的可视化编辑模式功能
	// 		enable_multilink: false, // boolean类型，按需开启，默认关闭，是否开启A/B实验的多链接实验功能，默认为false
	// 		multilink_timeout_ms: 1000 // number类型，A/B实验的多链接实验中关闭遮罩层的时间，默认500毫秒
	// 	})

	// 	// 必须在初始化配置完成后，加入这行代码，否则SDK不会发送数据
	// 	window.collectEvent('start') // 通知SDK设置完毕，可以真正开始发送事件了
	// 	// 公共属性
	// 	window.collectEvent('config', {
	// 		platform: 'PC'
	// 	})
	// 	// 客户端自行进入分流的话需要此代码 由服务端进行分流就不需要
	// 	// window.collectEvent('getVar', 'coupon_test', '2', () => {
	// 	// 	// console.log('火山ab测试ab参数', value)
	// 	// })
	// }

	const firstScript = document.head.querySelector('script')
	if (firstScript) {
		// 在第一个 script 后顺序插入
		firstScript.insertAdjacentElement('afterend', script1)
		// script1.insertAdjacentElement('afterend', script2)
	}
	else {
		// 直接追加到 head
		document.head.append(script1)
	}
}
